export class FeatureBase {
    featureId: number;
    name: string;
    isAccessEnabled: boolean;
    allowedCount: number;
}